import React from 'react';
import { 
  Modal, 
  Box, 
  IconButton,
  Typography,
  Stack
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Thread from './Thread';

const ThreadModal = ({ 
  open, 
  onClose, 
  messageId, 
  title = "Thread Discussion" 
}) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      BackdropProps={{
        sx: {
          zIndex: 9999,
          backgroundColor: 'rgba(0, 0, 0, 0.5)'
        }
      }}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 2,
        zIndex: 10000 // Higher than SmallMain chat app (9999)
      }}
    >
      <Box sx={{
        width: '90vw',
        maxWidth: 900,
        height: '90vh',
        bgcolor: 'background.paper',
        borderRadius: 3,
        boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        zIndex: 10001 // Even higher for the content box
      }}>
        {/* Modal Header */}
        <Box sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          p: 2,
          borderBottom: '1px solid',
          borderColor: 'divider',
          bgcolor: 'grey.50'
        }}>
          <Stack direction="row" alignItems="center" spacing={1}>
            <Typography variant="h6" sx={{ fontWeight: 700, color: 'primary.main' }}>
              🧵 {title}
            </Typography>
            {messageId && (
              <Typography variant="caption" sx={{ 
                color: 'text.secondary',
                px: 1,
                py: 0.5,
                bgcolor: 'grey.200',
                borderRadius: 1,
                fontSize: '0.75rem'
              }}>
                ID: {messageId.slice(-8)}
              </Typography>
            )}
          </Stack>
          
          <IconButton
            onClick={onClose}
            size="small"
            sx={{
              color: 'text.secondary',
              '&:hover': {
                bgcolor: 'error.50',
                color: 'error.main'
              }
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>

        {/* Thread Content */}
        <Box sx={{ 
          flex: 1, 
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column'
        }}>
          {messageId ? (
            <Thread messageId={messageId} />
          ) : (
            <Box sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              height: '100%',
              color: 'text.secondary'
            }}>
              <Stack alignItems="center" spacing={2}>
                <Typography variant="h6">
                  🔍 No Message Selected
                </Typography>
                <Typography variant="body2">
                  Please provide a message ID to view the thread.
                </Typography>
              </Stack>
            </Box>
          )}
        </Box>
      </Box>
    </Modal>
  );
};

export default ThreadModal;
